/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MassInDB, UnitType } from 'src/api';
import { ConceptInputComponent } from '../../../forms/input/concept-input.component';
import {
  LabelPosition,
  SwitchComponent,
  SwitchSize,
  InputType,
} from '@ansys-internal/awc-angular/forms';
import { ComponentWidth } from '@ansys-internal/awc-angular/core';
export type SetPart = [value: string, type: string, id: string, index?: number];

@Component({
    selector: 'app-mass-inputs',
    templateUrl: './mass.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [ConceptInputComponent, SwitchComponent]
})
export class MassComponent {
  @Input() part!: MassInDB;
  @Input() update!: boolean;
  @Input() readonly!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  @Output() forceUpdate: EventEmitter<string> = new EventEmitter<string>();
  protected UnitType = UnitType;
  protected InputTypes = InputType;
  protected labelPosition: LabelPosition = LabelPosition.BEFORE;
  protected size: SwitchSize = SwitchSize.MEDIUM;
  protected awcSizing: ComponentWidth = ComponentWidth.FILL;
  protected toggleIncludeComponentMass(toggle: boolean): void {
    this.part['add_components_mass'] = toggle;
    this.forceUpdate.emit('');
  }
}
